import { useState } from "react";

interface CharacterReference { name: string; position?: string; company?: string; phone?: string; email?: string }

const rows: [keyof CharacterReference, string][] = [
  ["name", "Name"],
  ["position", "Position"],
  ["company", "Company"],
  ["phone", "Contact Number"],
  ["email", "Email"],
];

const inputCls = "flex-1 rounded-btn border border-border-card bg-white px-2.5 py-1.5 text-xs text-near-black focus:outline-none focus:shadow-focus";

export function CharacterReferenceCard({ data, onChange, onDelete }: { data: CharacterReference; onChange: (updated: CharacterReference) => void; onDelete: () => void }) {
  const [editing, setEditing] = useState(!data.name);

  return (
    <div className="rounded-card border border-border-card bg-white p-4 shadow-card">
      <div className="flex items-start gap-3">
        <div className="flex-1 space-y-2">
          {editing ? (
            rows.map(([key, label]) => (
              <div key={key} className="flex items-center gap-3">
                <span className="w-28 shrink-0 text-xs font-semibold text-text-secondary">{label}</span>
                <input
                  value={data[key] || ""}
                  onChange={(e) => onChange({ ...data, [key]: e.target.value })}
                  placeholder={`Enter ${label.toLowerCase()}`}
                  className={inputCls}
                />
              </div>
            ))
          ) : (
            rows.map(([key, label]) => (
              <div key={key} className="flex justify-between border-b border-surface-secondary py-1 last:border-0">
                <span className="text-xs text-text-secondary">{label}</span>
                <span className="text-xs font-medium text-near-black">{data[key] || "—"}</span>
              </div>
            ))
          )}
        </div>

        <div className="flex shrink-0 items-center gap-1">
          <button
            onClick={() => setEditing((e) => !e)}
            title={editing ? "Done" : "Edit"}
            className="flex h-7 w-7 items-center justify-center rounded-btn text-text-secondary hover:bg-surface-secondary hover:text-near-black"
          >
            {editing ? (
              <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            ) : (
              <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931zm0 0L19.5 7.125" />
              </svg>
            )}
          </button>
          <button
            onClick={onDelete}
            title="Delete"
            className="flex h-7 w-7 items-center justify-center rounded-btn text-red-500 hover:bg-red-50 hover:text-red-600"
          >
            <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
